export const today = new Date();
export const currentYear = today.getFullYear();
export const currentMonth = today.getMonth();
export const firstSelectableDate = new Date(currentYear, 3, 1);
export const april = 3;
export const numberOfMonths =
  currentMonth >= april ? currentMonth - april + 1 : currentMonth + 12 - april + 1;
export const dateFormatNorsk = "dd.MM.yy";
export const dateFormatISO = "yyyy-MM-dd";
export const dateTimeFormatISO = `${dateFormatISO}'T'HH:mm:ss`;
export const calendarClasses = {
  root: "text-xl",
  month_caption: "ml-2.25 flex py-2 pb-3 justify-start capitalize",
  caption_label: "text-2xl text-ldir-brown-900 font-bold",
  nav: "flex items-between w-full",
  month_grid: "border-collapse mb-6",
  weekdays: "flex font-medium text-ldir-brown-900",
  weekday: "w-[calc((100vw-48px)/7)] max-w-15 max-h-15 font-bold",
  week: "flex mt-2",
  day: "text-ldir-brown-900 rounded-full h-[calc((100vw-48px)/7)] w-[calc((100vw-48px)/7)] max-w-15 max-h-15 text-center  p-0 relative [&:has([aria-selected].day-range-end)]:rounded-r-md [&:has([aria-selected].day-outside)]:bg-ldir-brown-900/20 [&:has([aria-selected].day-outside)]:text-white first:[&:has([aria-selected])]:rounded-l-md last:[&:has([aria-selected])]:rounded-r-md focus-within:relative focus-within:z-20",
  day_button: "h-[calc((100vw-48px)/7)] w-[calc((100vw-48px)/7)] max-w-15 max-h-15 p-0 font-normal",
  range_end: "day-range-end",
  selected: "rounded-full border-none bg-ldir-blue-900 text-white font-bold",
  today: "ring-2 ring-ldir-blue-900 ring-inset rounded-full text-ldir-brown-900 ",
  outside:
    "day-outside text-ldir-brown-700 opacity-50 aria-selected:bg-brown-700 aria-selected:text-ldir-brown-900 aria-selected:bg-opacity-10",
  disabled: "text-ldir-brown-700 opacity-50",
  hidden: "text-ldir-brown-700 opacity-50 visible",
};
